import { Grid } from '@mui/material';
import { styled } from '@mui/system';

export const GridWithRestrictedSize = styled(Grid)`
  margin: 0 auto;
  max-width: 1800px;
  width: 100%;
`;
